import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Invoice, InvoiceParams } from './types';

export const GET_INVOICE_LIST = 'invoices/GET_INVOICE_LIST';
export const GET_INVOICE_LIST_SUCCESS = 'invoices/GET_INVOICE_LIST_SUCCESS';
export const GET_INVOICE_LIST_ERROR = 'invoices/GET_INVOICE_LIST_ERROR';

export const UPDATE_INVOICE = 'invoices/UPDATE_INVOICE';
export const UPDATE_INVOICE_SUCCESS = 'invoices/UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_ERROR = 'invoices/UPDATE_INVOICE_ERROR';

export const DELETE_INVOICE = 'invoices/DELETE_INVOICE';
export const DELETE_INVOICE_SUCCESS = 'invoices/DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_ERROR = 'invoices/DELETE_INVOICE_ERROR';

export const GET_INVOICE_DETAIL = 'invoices/GET_INVOICE_DETAIL';
export const GET_INVOICE_DETAIL_SUCCESS = 'invoices/GET_INVOICE_DETAIL_SUCCESS';
export const GET_INVOICE_DETAIL_ERROR = 'invoices/GET_INVOICE_DETAIL_ERROR';

export const CREATE_INVOICE = 'invoices/CREATE_INVOICE';
export const CREATE_INVOICE_SUCCESS = 'invoices/CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_ERROR = 'invoices/CREATE_INVOICE_ERROR';

export const CREATE_INVOICE_EVALUATION = 'invoices/CREATE_INVOICE_EVALUATION';
export const CREATE_INVOICE_EVALUATION_SUCCESS =
  'invoices/CREATE_INVOICE_EVALUATION_SUCCESS';
export const CREATE_INVOICE_EVALUATION_ERROR =
  'invoices/CREATE_INVOICE_EVALUATION_ERROR';

export const DELETE_INVOICE_EVALUATION = 'invoices/DELETE_INVOICE_EVALUATION';
export const DELETE_INVOICE_EVALUATION_SUCCESS =
  'invoices/DELETE_INVOICE_EVALUATION_SUCCESS';
export const DELETE_INVOICE_EVALUATION_ERROR =
  'invoices/DELETE_INVOICE_EVALUATION_ERROR';

export const CREATE_INVOICE_COMMENT = 'invoices/CREATE_INVOICE_COMMENT';
export const CREATE_INVOICE_COMMENT_SUCCESS =
  'invoices/CREATE_INVOICE_COMMENT_SUCCESS';
export const CREATE_INVOICE_COMMENT_ERROR =
  'invoices/CREATE_INVOICE_COMMENT_ERROR';

export const CREATE_INVOICE_PAYMENT = 'invoices/CREATE_INVOICE_PAYMENT';
export const CREATE_INVOICE_PAYMENT_SUCCESS =
  'invoices/CREATE_INVOICE_PAYMENT_SUCCESS';
export const CREATE_INVOICE_PAYMENT_ERROR =
  'invoices/CREATE_INVOICE_PAYMENT_ERROR';

export const CREATE_SUB_INVOICE = 'invoices/CREATE_SUB_INVOICE';
export const CREATE_SUB_INVOICE_SUCCESS = 'invoices/CREATE_SUB_INVOICE_SUCCESS';
export const CREATE_SUB_INVOICE_ERROR = 'invoices/CREATE_SUB_INVOICE_ERROR';

export const EXCLUDE_SUB_INVOICE = 'invoices/EXCLUDE_SUB_INVOICE';
export const EXCLUDE_SUB_INVOICE_SUCCESS =
  'invoices/EXCLUDE_SUB_INVOICE_SUCCESS';
export const EXCLUDE_SUB_INVOICE_ERROR = 'invoices/EXCLUDE_SUB_INVOICE_ERROR';

export const UPDATE_INVOICE_STATUS = 'invoices/UPDATE_INVOICE_STATUS';
export const UPDATE_INVOICE_STATUS_SUCCESS =
  'invoices/UPDATE_INVOICE_STATUS_SUCCESS';
export const UPDATE_INVOICE_STATUS_ERROR =
  'invoices/UPDATE_INVOICE_STATUS_ERROR';

export const CHANGE_INVOICE_PRICE = 'invoices/CHANGE_INVOICE_PRICE';
export const CHANGE_INVOICE_PRICE_SUCCESS =
  'invoices/CHANGE_INVOICE_PRICE_SUCCESS';
export const CHANGE_INVOICE_PRICE_ERROR = 'invoices/CHANGE_INVOICE_PRICE_ERROR';

export const MAPPING_TAX_INVOICE = 'invoices/MAPPING_TAX_INVOICE';
export const MAPPING_TAX_INVOICE_SUCCESS =
  'invoices/MAPPING_TAX_INVOICE_SUCCESS';
export const MAPPING_TAX_INVOICE_ERROR = 'invoices/MAPPING_TAX_INVOICE_ERROR';

export const getInvoiceListAsync = createAsyncAction(
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_SUCCESS,
  GET_INVOICE_LIST_ERROR,
)<InvoiceParams, Invoice[], AxiosError>();

export const updateInvoiceAsync = createAsyncAction(
  UPDATE_INVOICE,
  UPDATE_INVOICE_SUCCESS,
  UPDATE_INVOICE_ERROR,
)<InvoiceParams, Invoice, AxiosError>();

export const deleteInvoiceAsync = createAsyncAction(
  DELETE_INVOICE,
  DELETE_INVOICE_SUCCESS,
  DELETE_INVOICE_ERROR,
)<InvoiceParams, any, AxiosError>();

export const getInvoiceDetailAsync = createAsyncAction(
  GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL_SUCCESS,
  GET_INVOICE_DETAIL_ERROR,
)<InvoiceParams, Invoice, AxiosError>();

export const createInvoiceAsync = createAsyncAction(
  CREATE_INVOICE,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_ERROR,
)<InvoiceParams, Invoice, AxiosError>();

export const createInvoiceCommentAsync = createAsyncAction(
  CREATE_INVOICE_COMMENT,
  CREATE_INVOICE_COMMENT_SUCCESS,
  CREATE_INVOICE_COMMENT_ERROR,
)<any, Invoice, AxiosError>();

export const createInvoicePaymentAsync = createAsyncAction(
  CREATE_INVOICE_PAYMENT,
  CREATE_INVOICE_PAYMENT_SUCCESS,
  CREATE_INVOICE_PAYMENT_ERROR,
)<any, Invoice, AxiosError>();

export const createSubInvoiceAsync = createAsyncAction(
  CREATE_SUB_INVOICE,
  CREATE_SUB_INVOICE_SUCCESS,
  CREATE_SUB_INVOICE_ERROR,
)<any, Invoice[], AxiosError>();

export const excludeSubInvoiceAsync = createAsyncAction(
  EXCLUDE_SUB_INVOICE,
  EXCLUDE_SUB_INVOICE_SUCCESS,
  EXCLUDE_SUB_INVOICE_ERROR,
)<any, Invoice[], AxiosError>();

export const updateInvoiceStatusAsync = createAsyncAction(
  UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
)<InvoiceParams, Invoice, AxiosError>();

export const changeInvoicePriceAsync = createAsyncAction(
  CHANGE_INVOICE_PRICE,
  CHANGE_INVOICE_PRICE_SUCCESS,
  CHANGE_INVOICE_PRICE_ERROR,
)<InvoiceParams, Invoice, AxiosError>();

export const mappingTaxInvoiceAsync = createAsyncAction(
  MAPPING_TAX_INVOICE,
  MAPPING_TAX_INVOICE_SUCCESS,
  MAPPING_TAX_INVOICE_ERROR,
)<InvoiceParams, Invoice, AxiosError>();
